module.exports = __webpack_public_path__ + "img/sample-report.209e9da7.png";